import { Typography } from '@material-ui/core';
import { css } from '@emotion/react';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';

const confirmationTitleCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_text_primary};
		font-size: 3.6rem;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		letter-spacing: normal;
		margin-bottom: 26px;
		line-height: 44px;
	}
`;

interface PageProps {
	confirmationTitle: string;
}

const Title = (props: PageProps) => {
	const { colors } = useColors();
	return (
		<Typography variant="h5" css={confirmationTitleCss(colors)}>
			{props.confirmationTitle}
		</Typography>
	);
};

export default Title;
